import { connect } from 'react-redux'
import CreateOrganization from '../../components/organizations/create/CreateOrganizationPane'
import {
  createOrg,
  updateOrganization,
  createOrganizationBankAccount,
  createOrganizationLegalEntity,
  createOrgClear,
  removeOrganizationBankAccount,
  setOrganizationDefaultBankAccount,
  getOrganizationLegalEntity,
  clearOrganizationLegalEntity,
  createOrgSubscription,
  updateOrgSubscription,
  actionCreators
} from '../../state/actions/organizations/'
import { getOrganizationProcessing, getOrganizationProcessingError } from '../../state/reducers/organizations'
import {
  ICreateBankAccountObj,
  ILegalEntityObj,
  IOrgObj,
  IOrgCreateObj,
  IStoreState,
  ICreateOrgSubscriptionDTO,
  IUpdateOrgSubscriptionDTO
} from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any) {
  let connectURL: string | undefined = ''
  if (state.organizations.newOrgId) {
    const newOrgId = state.organizations.newOrgId
    connectURL =
      state.organizations.items[newOrgId] && state.organizations.items[newOrgId].legalEntity
        ? state.organizations.items[newOrgId].legalEntity.connectURL
        : undefined
  }
  return {
    bankAccounts: state.organizationsBankAccounts.items,
    legalEntity: state.organizationLegalEntity.entity,
    orgId: state.organizations.newOrgId,
    currentOrgId: state.organizations.currentOrgId,
    metadata: state.organizations.metadata,
    creating: getOrganizationProcessing(state),
    error: getOrganizationProcessingError(state),
    routeProps: ownProps,
    connectURL
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    createOrg: (data: IOrgCreateObj, setCurrent?: boolean) => dispatch(createOrg(data, setCurrent)),
    updateOrg: (data: IOrgObj) => dispatch(updateOrganization(data)),
    createOrgClear: () => {
      dispatch(createOrgClear())
      dispatch(clearOrganizationLegalEntity())
    },
    getOrganizationLegalEntity: (orgId: string) => dispatch(getOrganizationLegalEntity(orgId)),
    createOrganizationBankAccount: (data: ICreateBankAccountObj, orgId: string) => {
      return new Promise((approve, reject) => {
        dispatch(createOrganizationBankAccount(data, orgId)).then(() => {
          dispatch(getOrganizationLegalEntity(orgId)).then(() => {
            approve()
          })
        })
      })
    },
    createOrganizationLegalEntity: (data: ILegalEntityObj, orgId: string) =>
      dispatch(createOrganizationLegalEntity(data, orgId)),
    removeOrganizationBankAccount: (orgId: string, bankAccountId: string) => {
      return new Promise((approve, reject) => {
        dispatch(removeOrganizationBankAccount(orgId, bankAccountId)).then(() => {
          dispatch(getOrganizationLegalEntity(orgId)).then(() => {
            approve()
          })
        })
      })
    },
    createOrgSubscription: (dto: ICreateOrgSubscriptionDTO) => dispatch(createOrgSubscription(dto)),
    updateOrgSubscription: (dto: IUpdateOrgSubscriptionDTO) => dispatch(updateOrgSubscription(dto)),
    setOrganizationDefaultBankAccount: (orgId: string, bankAccountId: string) =>
      dispatch(setOrganizationDefaultBankAccount(orgId, bankAccountId)),
    resetOrgMetadata: () => dispatch(actionCreators.resetOrgMetadata())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateOrganization)



// WEBPACK FOOTER //
// ./src/containers/organizations/CreateOrganization.ts